/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router';
// material
import { Division, InContentMessage, Page } from '@insticator/insticator-ui'; // iui-material
// pages
import RevenuePage from './revenue/revenue';
import UnitLoadRPMPage from './unitloadrpm/unitloadrpm';
import UnitLoadsPage from './unitloads/unitloads';
import EngagementProductsPage from "./engagementproducts/engagementproducts";
import ConfigurationPage from "./configuration/configuration";
import FullAdManagementPage from "./fulladmanagement/fulladmanagement";
import MobileAppPage from "./mobileapp/mobileapp";
import VideoAdManagementPage from "./videoadmangement/videoadmangement";
import SupplySidePlatformPage from "./supplysideplatform/supplysideplatform";
// utils
import { serialize } from '../../../utils/serialize';
import { getDevices } from '../../../utils/filterhelpers';
// thunks
import { fetchRevenueDetailData } from '../../../state/thunks/revenue';
// styles
import injectSheet from 'react-jss';
import styles from './monetization_styles';



/* ========== ~~~~~~~~~~ MONETIZATION DIVISION ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
    // state
    const accountUUID = useSelector((state) => state.session.accountUUID);
    const startDate = useSelector((state) => state.app.filters.dateRange.from);
    const endDate = useSelector((state) => state.app.filters.dateRange.to);
    const compareTo = useSelector((state) => state.app.filters.compareTo);
    const devices = useSelector((state) => state.app.filters.devices);
    const countries = useSelector((state) => state.app.filters.countries);
    const siteUUIDs = useSelector((state) => state.app.filters.sites);
    const requestStatus = useSelector((state) => state.revenue.status);

    // actions
    const dispatch = useDispatch();

    // test revenue request
    useEffect(() => {
        requestRevenueData()
    }, [siteUUIDs, devices, compareTo, countries]);

    // data
    const requestRevenueData = () => {
        if (requestStatus === 'pending' || startDate === null || endDate === null) return null;
        dispatch(fetchRevenueDetailData(getRevenueRequestData()))
    };

    const getRevenueRequestData = () => serialize({
        accountUUID,
        siteUUIDs,
        startDate,
        endDate,
        compareTo,
        devices: getDevices(devices, 'monetization'),
        countries
    })

    return(
        <Division name={`monetization`} klass={props.classes.monetization}>
            <Switch>
                {/*Routes to subdivisions*/}
                <Route exact path='/dashboard/monetization'>
                    <RevenuePage dataRequest={requestRevenueData} />
                </Route>
                <Route path='/dashboard/monetization/revenue'>
                    <RevenuePage dataRequest={requestRevenueData} />
                </Route>
                <Route path='/dashboard/monetization/unitloadrpm'>
                    <UnitLoadRPMPage dataRequest={requestRevenueData} />
                </Route>
                <Route path='/dashboard/monetization/unitloads'>
                    <UnitLoadsPage dataRequest={requestRevenueData} />
                </Route>
                <Redirect to='/error/404'/>
            </Switch>
        </Division>
    )
});
